import { render, staticRenderFns } from "./vip_salon.vue?vue&type=template&id=c6a5edd2&scoped=true"
import script from "./vip_salon.vue?vue&type=script&lang=js"
export * from "./vip_salon.vue?vue&type=script&lang=js"
import style0 from "./vip_salon.vue?vue&type=style&index=0&id=c6a5edd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a5edd2",
  null
  
)

export default component.exports